import dateUtils, { dateLib } from "@/utils/date";


export const useFideliteCarrefour = () => {
  

  const temps2 = useRuntimeConfig().public.CARREFOUR_FIDELITE_TEMPS_2_DATE;

  const isTemps2Fidelite = computed(() => {
    const today = dateLib();
    const dateTemps2 = dateLib(temps2);

    return today.isAfter(dateTemps2);
  })

  return {
    isTemps2Fidelite
  }
}